import { request } from '@/shared/api/request'

export const getEmployeeAffairs = ({ srcText = '', page = 0, size = 50 }) =>
    request({
        url: `contract/persCard/employee/searchReq?srcText=${srcText}&page=${page}&size=${size}`,
        method: 'GET'
    })

export const getEmployeeCard = () => request({ url: 'contract/persCard/employee/getCard', method: 'GET' })
